module.exports = __webpack_public_path__ + "img/chrome.89de877d.png";